addTypePolicies